import { AdminBlockAttributeInputType, AdminBlockTypeAttribute } from '@headlines/types/block/adminBlockType';

const isBorderEnabled: AdminBlockTypeAttribute = {
  label: 'Show border',
  key: 'isBorderEnabled',
  inputType: AdminBlockAttributeInputType.CHECKBOX,
};

export default isBorderEnabled;
